<div [class.header]="!compact" [class.top-bar-actions]="compact" [class.academy-mode-active]="academyMode" [class.isd-iop-mode-active]="isdIopMode" [class.parent-mode-active]="parentMode">
  @if (!compact) {
    <div class="side-menu-buttons-header"><div class="client-name d-flex" id="clientName">
      {{ title }}<ng-content select="[header-status]" />
    </div></div>
  }
  <div class="top-bar-actions" (clickOutside)="setOpenMenu(false)" [additionalElementRefs]="[]">
    <ng-content select="[header-actions]" />
    <button class="side-menu-button2 me-3" id="sideMenuButton" (click)="setOpenMenu(!openMenu)" [attr.aria-expanded]="openMenu">
      Menu<span *ngIf="hasUpdateAvailable" class="menu-alert-dot" aria-hidden="true"></span>
    </button>
    @if (openMenu) {
      <div class="side-menu-buttons menu-top" id="sideMenuButtons" [class.academy-mode-active]="academyMode" [class.isd-iop-mode-active]="isdIopMode" [class.parent-mode-active]="parentMode">
        <div class="top-bar-meta text-muted small px-2 py-1 w-100 d-flex align-items-center justify-content-between flex-wrap">
          <span *ngIf="loggedInUsername" class="logged-as-block"><span class="d-block">Logged as:</span><span class="d-block">{{ loggedInUsername }}</span></span>
          <button class="send-logs-link" id="sendLogsLink" (click)="sendLogs.emit()" [disabled]="sendingLogs">{{ sendingLogs ? 'Sending...' : 'Send logs' }}</button>
        </div>
        <ng-content select="[menu-before-patient]" />
        @if (showPatientSelector && patients.length > 0) {
          <div class="text-center w-100" id="selectedPatientDropdown">
            <p-dropdown styleClass="w-100 patient-select-dropdown" panelStyleClass="patient-select-dropdown-panel" appendTo="body"
              [style]="{width: '100%'}" [options]="patients" [ngModel]="selectedPatientID" placeholder="Select a patient"
              [filter]="true" filterBy="searchString,FullName" optionLabel="FullName" optionValue="ID"
              [virtualScroll]="true" [virtualScrollItemSize]="50" (onChange)="patientChanged.emit($event.value)">
              <ng-template pTemplate="selectedItem" let-option><div class="flex align-items-center gap-2">{{ option.FullName }}</div></ng-template>
            </p-dropdown>
          </div>
        }
        <ng-content select="[menu-session-actions]" />
        <hr />
        <button id="offlinePatientsButton" (click)="offlinePatients.emit(); setOpenMenu(false)" [class.side-menu-button2]="!offlinePatientsActive" [class.updates-button]="offlinePatientsActive" style="min-width: 100%">Offline Patients</button>
        <ng-content select="[menu-settings]" />
        <button *ngIf="showSignOut" id="signOutButton" class="side-menu-button2" style="width: 100%" (click)="signOut.emit()" [disabled]="signingOut">Sign Out</button>
        <ng-content select="[menu-app-actions]" />
      </div>
    }
  </div>
</div>
